import React, { createContext, MutableRefObject, ReactElement, useEffect, useRef, useState } from 'react'
import { ReactState, StateSetter } from '../Types/Types'
import { Page } from '../../../NonReact/constants/Components/Page'
import { getPageName } from '../../../NonReact/common/DataIngest'

/**
 * JSP page context type.
 */
export type JSPPageContextType = Page | undefined

/**
 * Provider component properties type.
 */
type Props = {
    children: React.ReactNode
}

const MAX_RETRIES: number = 1000

/**
 * Provides access to current JSP page.
 * @param children Children to render.
 */
export const JSPPageContextProvider = ({ children }: Props): ReactElement => {
    const [pageName, setPageName]: ReactState<Page> = useState<Page>(Page.WELCOME)
    const numberOfRetries: MutableRefObject<number> = useRef(0)

    const initialise = (setter: StateSetter<Page>): void => {
        const name: Page = getPageName()

        if (!name && numberOfRetries.current <= MAX_RETRIES) {
            numberOfRetries.current += 1
            setTimeout((): void => initialise(setter), 100)
        } else {
            setter(name)
        }
    }

    useEffect((): void => {
        initialise(setPageName)
    }, [])

    return <JSPPageContext.Provider value={pageName}>{children}</JSPPageContext.Provider>
}

/**
 * Context for current JSP page.
 */
const JSPPageContext = createContext<JSPPageContextType>(undefined)
export default JSPPageContext
